import moment from 'moment'

import services from '@/services/ascentiaServiceIndex'
import { FULLFLIGHT_CONSTS as FC } from '../consts'

const state = {
  tails: [],
  flights: [],
  parameters: [],
  fullFlightData: [],
  parameterChoices: [],
  systems: ['EPGS'],
  selections: [],
  saveFiltersFlag: false,
}

const storageKeys = {
  userSaveFlag: 'userSaveFlag',
  userParameterFilters: 'userSavedParameterFilters',
}

const getters = {
  tailsOnly: state => {
    return Object.keys(state.tails)
  },
  filteredFullFlightData: state => {
    const dataToRet = state.selections
      .filter(selection => {
        return state.fullFlightData[selection.id]
      })
      .map(selection => {
        const tempKeys = state.fullFlightData[selection.id].keys
        return {
          data: state.fullFlightData[selection.id].data
            .map(ffd => ffd.data)
            .reduce(
              (acc, ffd) =>
                acc.concat(Object.freeze(ffd.map(dp => Object.freeze(dp)))),
              [],
            ),
          // .map(dataPoint => Object.freeze([dataPoint[0], dataPoint[1]])),
          keys: tempKeys,
          aircraft: selection.aircraft,
          hidden: selection.hidden,
          component: selection.componentName,
          parameter: selection.paramName,
          flightMappings: state.fullFlightData[selection.id].flightMappings,
          unit:
            tempKeys && Object.keys(tempKeys).length > 0
              ? 'keyed'
              : state.fullFlightData[selection.id].unit,
        }
      })
    Object.freeze(dataToRet.keys)
    Object.freeze(dataToRet.data)
    Object.freeze(dataToRet)
    return dataToRet
  },
  filteredParamData: state => {
    return state.selections
      .filter(selection => {
        return selection.parameter && selection.tailNum
      })
      .map(selection => {
        let data = state.parameters
          .sort((a, b) => {
            return a.date < b.date ? 1 : -1
          })
          .filter(param => {
            return (
              param.tail === selection.tailNum &&
              param.parameter === selection.parameter &&
              param.date <= selection.deptDate
            )
          })
          .slice(0, selection.flightNum)
        data = []
          .concat(
            ...data.map(item =>
              item.data.map(dataPoint => [+moment(dataPoint[0]), dataPoint[1]]),
            ),
          )
          .sort((a, b) => (a[0] < b[0] ? -1 : 1))
        return {
          data: data,
          aircraft: selection.tailNum,
          hidden: selection.hidden,
          component: selection.componentName,
          parameter: selection.paramName,
          unit: selection.unit,
        }
      })
  },
  getSaveFiltersFlag: state => {
    return state.saveFiltersFlag
  },
}

const mutations = {
  [FC.UPDATE_PARAMETER_DATA]: (state, data) => (state.parameterChoices = data),
  [FC.UPDATE_TAIL_DATA]: (state, data) => (state.tails = data),
  [FC.UPDATE_FLIGHT_DATA]: (state, data) => {
    const flightObj = state.flights.filter(item => item.flight === data.flight)
    if (flightObj.length === 0) {
      state.flights.push({
        tail: data.tail,
        flight: data.flight,
        recordStartDate: data.recordStartDate,
        timestamp: data.timestamp,
      })
      state.flights = state.flights.sort((a, b) =>
        a.recordStartDate <= b.recordStartDate ? 1 : -1,
      )
    }
  },
  [FC.UPDATE_FLIGHT_PARAMETER_DATA]: (state, data) => {
    // verifying tail commit
    if (state.tails.indexOf(data.tail) === -1) {
      state.tails.push(data.tail)
    }
    // verifying flight commit
    const flightObj = state.flights.filter(item => item.flight === data.flight)
    if (flightObj.length === 0) {
      state.flights.push({
        tail: data.tail,
        flight: data.flight,
        recordStartDate: data.recordStartDate,
      })
    }

    // verifying param commit
    let paramObj = state.parameters.filter(
      item => item.flight === data.flight && item.parameter === data.parameter,
    )
    if (paramObj.length === 0) {
      paramObj = {
        tail: data.tail,
        flight: data.flight,
        parameter: data.parameter,
        data: data.data,
        keys: data.keys,
        date: data.recordStartDate,
      }
      state.parameters.push(paramObj)
    }
  },
  [FC.UPDATE_FULL_FLIGHT_PARAMETER_DATA]: (state, data) => {
    state.fullFlightData = {
      ...state.fullFlightData,
      [data.selectorId]: {
        data: data.data,
        keys: data.keys,
        unit: data.unit,
        flightMappings: data.flightMappings,
      },
    }
  },
  [FC.ADD_SELECTOR]: (state, selector) => {
    state.selections.push(selector)
  },
  [FC.UPDATE_SELECTOR]: (state, selector) => {
    const curIdx = state.selections
      .map(selection => selection.id)
      .indexOf(selector.id)
    state.selections.splice(curIdx, 1, selector)
  },
  [FC.UPDATE_SELECTOR_NODATA]: (state, selector) => {
    const curIdx = state.selections
      .map(selection => selection.id)
      .indexOf(selector.id)
    state.selections[curIdx].noData = selector.noData
  },
  [FC.REMOVE_SELECTOR]: (state, selector) => {
    const curId = state.selections
      .map(selection => selection.id)
      .indexOf(selector.id)
    state.selections.splice(curId, 1)
  },
  [FC.HIDE_PARAM]: (state, selectorId) => {
    state.selections = state.selections.map(selection => {
      if (selection.id === selectorId) {
        selection.hidden = !selection.hidden
      }
      return selection
    })
  },
  [FC.UPDATE_MULTI_FLIGHT_LOADING_SELECTOR]: (state, data) => {
    state.selections = state.selections.map(selection => {
      if (selection.id === data.selectorId) {
        selection.loading = data.loading
      }
      return selection
    })
  },
  [FC.UPDATE_LOADING_SELECTOR]: (state, data) => {
    const curData = (state.fullFlightData[data.selectorId] || { data: null })
      .data
    state.selections = state.selections.map(selection => {
      if (selection.id === data.selectorId) {
        selection.loading = data.loading
        selection.noData = !(curData && curData.length > 0)
      }
      return selection
    })
  },
  [FC.UPDATE_SAVE_FILTERS_FLAG]: (state, data) => {
    state.saveFiltersFlag = data
    window.localStorage.setItem(storageKeys.userSaveFlag, state.saveFiltersFlag)
  },
}

const actions = {
  async [FC.GET_COMPLETE_FULL_FLIGHT_DATA]({ commit }, selector) {
    try {
      commit(FC.UPDATE_LOADING_SELECTOR, {
        selectorId: selector.id,
        loading: true,
      })

      let response
      // Switch API based on parameter selection
      if (
        Object.prototype.hasOwnProperty.call(selector, 'isCustomParameter') &&
        selector.isCustomParameter
      ) {
        response = await services.derivedParameters.getData(
          'derivedParamFlightData',
          selector,
          true,
        )
      } else {
        response = await services.fullflight.getData(
          'fullFlightData',
          selector,
          true,
        )
      }

      if (response) {
        const firstSeries =
          response.data.dataSeries && response.data.dataSeries.length > 0
            ? response.data.dataSeries[0]
            : { unit: '' }
        const commitObj = {
          selectorId: selector.id,
          data: response.data.dataSeries.reduce(
            (acc, curVal) => acc.concat(curVal),
            [],
          ),
          keys: response.data.dataKeys,
          flightMappings: response.data.flightMappings,
          unit: firstSeries.unit,
        }
        Object.freeze(commitObj.keys)
        Object.freeze(commitObj.data)
        Object.freeze(commitObj.flightMappings)
        Object.freeze(commitObj)
        commit(FC.UPDATE_FULL_FLIGHT_PARAMETER_DATA, commitObj)
      } else {
        commit(FC.UPDATE_FULL_FLIGHT_PARAMETER_DATA, {
          selectorId: selector.id,
          data: [],
          keys: [],
          flightMappings: [],
          unit: '',
        })
      }
    } catch (error) {
      console.log(`${FC.GET_COMPLETE_FULL_FLIGHT_DATA}: error ${error}`)
      commit(FC.UPDATE_FULL_FLIGHT_PARAMETER_DATA, {
        selectorId: selector.id,
        data: [],
        keys: [],
        flightMappings: [],
        unit: '',
      })
    } finally {
      commit(FC.UPDATE_SELECTOR, selector)
      commit(FC.UPDATE_LOADING_SELECTOR, {
        selectorId: selector.id,
        loading: false,
      })
    }
  },
  async [FC.GET_TAIL_DATA]({ commit, rootGetters }) {
    try {
      const response = await services.lookup.getData('tailData')
      const data = response.data
        .filter(item => {
          // Global Airline Filter
          if (rootGetters['globalFilter/showAllAirlines']) {
            return true
          } else {
            return (
              rootGetters['globalFilter/airlineIdsSelected'].indexOf(
                item.airlineId,
              ) > -1
            )
          }
        })
        .map(tail => tail.name)
      commit(FC.UPDATE_TAIL_DATA, data)
    } catch (error) {
      console.log('getDataAsync: error ' + error)
    }
  },
  async [FC.GET_FLIGHT_DATA]({ commit }, flightOpts) {
    const flights = await services.fullflight.getData(
      'flightData',
      flightOpts,
      true,
    )
    flights.data.data.forEach(function (flight) {
      commit(FC.UPDATE_FLIGHT_DATA, {
        tail: flight.tailNumber,
        flight: flight.id,
        recordStartDate: flight.recordStartDate,
        timestamp: flight._ts,
      })
    })
  },
  async [FC.GET_FLIGHT_PARAMETER_DATA]({ state, commit }, selectorId) {
    const flightParams = state.selections
      .filter(selection => selection.id === selectorId)
      .map(selection => {
        return {
          ...selection,
          deptDate: moment(
            selection.deptDate,
            'ddd MMM DD YYYY HH:mm:ss Z',
          ).format('YYYYMMDD'),
        }
      })
    if (flightParams && flightParams.length > 0) {
      commit(FC.UPDATE_MULTI_FLIGHT_LOADING_SELECTOR, {
        selectorId,
        loading: true,
      })
      try {
        const flightParamOpts = flightParams[0]
        const recDate = flightParamOpts.deptDate
        await services.fullflight.getData('flightData', {
          airline: flightParamOpts.operator,
          tail: flightParamOpts.tailNum,
          deptDate: recDate,
          numFlights: flightParamOpts.flightNum,
        })

        const curFlights = state.flights
          .filter(
            item =>
              item.tail === flightParamOpts.tailNum &&
              item.recordStartDate <= flightParamOpts.deptDate,
          )
          .sort((a, b) => (a.recordStartDate < b.recordStartDate ? 1 : -1))
        const flightId = curFlights[0] ? curFlights[0].flight : ''

        const firstFlightIdx = curFlights
          .map(item => item.flight)
          .indexOf(flightId)
        const flightArr = curFlights
          .map(item => item.flight)
          .slice(firstFlightIdx, firstFlightIdx + flightParamOpts.flightNum)

        const parameterArr = flightArr
          .filter(flight => {
            const parameter = state.parameters.filter(param => {
              return (
                param.tail === flightParamOpts.tail &&
                param.flight === flight &&
                param.parameter === flightParamOpts.parameter
              )
            })
            return parameter.length === 0 || parameter[0].data.length === 0
          })
          .map(item => {
            return {
              flight: item,
              promise: services.fullflight.getData(
                'parameterData',
                {
                  operator: flightParamOpts.operator,
                  tailByNum: flightParamOpts.tailNum,
                  flightId: item,
                  parameter: flightParamOpts.parameter,
                },
                true,
              ),
            }
          })
        // Takes the flight data array and introduces a function to add the data to charts.
        // I wanted this to load the data to the charts in order, so it waits on each call in order.
        //  Because of the above array, the promises should already be pulling data in order.
        //  If they load out of order (e.g. 1, 3, 2) it would display 1 when done, wait on 3
        //    because the 2nd promise hadn't completed, and then do both 2 and 3 once 2 completes.
        await parameterArr.reduce(async (acc, cur) => {
          await acc
          const curProm = await cur.promise
          const curData = curProm.data
          const flightData = curData.dataSeries[0]
          let formatStr = 'YYMMDD_HHmmss'
          if (flightData.recordStartDate.indexOf('_') > 7) {
            formatStr = 'YYYYMMDD'
          }
          const flightDate = moment(flightData.recordStartDate, formatStr)
          let dateForTimestamp = moment(flightData.recordStartDate, formatStr)
          let lastTime = null
          const dataPoints = []
          let dateUpdated = false
          for (const idx in flightData.data) {
            const item = flightData.data[idx]

            if (item[0].length < 13) {
              const time = moment(item[0], 'HH:mm:ss.SSS')
              if (lastTime === null) {
                lastTime = time
              }

              if (time.isBefore(lastTime) && !dateUpdated) {
                dateUpdated = true
                dateForTimestamp = dateForTimestamp.add(1, 'days')
              }
              const dateTime = moment(
                dateForTimestamp.format('YYYYMMDD') +
                  ' ' +
                  time.format('HH:mm:ss.SSS'),
                'YYYYMMDD HH:mm:ss.SSS',
              )
              lastTime = time
              dataPoints.push([+dateTime, parseFloat(item[1])])
            } else {
              dataPoints.push([
                +moment(item[0], 'MM/DD/YYYY HH:mm:ss'),
                parseFloat(item[1]),
              ])
            }
          }
          commit(FC.UPDATE_FLIGHT_PARAMETER_DATA, {
            tail: flightParamOpts.tailNum,
            flight: cur.flight,
            parameter: flightParamOpts.parameter,
            recordStartDate: flightDate,
            data: dataPoints,
            keys: flightData.dataKeys,
          })
        }, new Promise(resolve => resolve()))
        commit(FC.UPDATE_MULTI_FLIGHT_LOADING_SELECTOR, {
          selectorId,
          loading: false,
        })
      } catch (ex) {
        commit(FC.UPDATE_MULTI_FLIGHT_LOADING_SELECTOR, {
          selectorId,
          loading: false,
        })
        console.log(FC.GET_FLIGHT_PARAMETER_DATA + 'error: ' + ex)
      }
    }
  },
  [FC.SAVE_USER_FILTERS]({ state }) {
    const filtersToSave = state.saveFiltersFlag ? state.selections : []
    window.localStorage.setItem(
      storageKeys.userParameterFilters,
      JSON.stringify(filtersToSave),
    )
  },
  [FC.LOAD_USER_FILTERS]({ state }) {
    if (state.saveFiltersFlag) {
      try {
        const savedSelectionsStr = window.localStorage.getItem(
          storageKeys.userParameterFilters,
        )
        if (savedSelectionsStr) {
          const savedSelections = JSON.parse(savedSelectionsStr)
          savedSelections.forEach(sel => {
            sel.deptDate = moment().toDate()
          })
          state.selections = savedSelections
        }
      } catch (error) {
        console.log(
          'Failed to load previously selected parameter filters ' + error,
        )
      }
    }
  },
  [FC.LOAD_SAVE_FILTERS_FLAG]({ state }) {
    try {
      const savedFlag = window.localStorage.getItem(storageKeys.userSaveFlag)
      state.saveFiltersFlag = savedFlag === 'true'
    } catch (error) {
      console.log('Failed to load previously selected save flag ' + error)
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
